import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/lowData.tsx
var LowData = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M12 13.5011L8.75 10.2511M5.17886 19.7491C1.84946 16.1197 1.94293 10.4767 5.45926 6.96036C9.07161 3.34801 14.9284 3.34801 18.5407 6.96036C22.0571 10.4767 22.1505 16.1197 18.8211 19.7491",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.0104 7.49057C14.6909 4.17111 9.30904 4.17111 5.98959 7.49057C2.7585 10.7217 2.67247 15.9073 5.73154 19.242C6.01154 19.5472 5.99109 20.0217 5.68585 20.3017C5.38062 20.5817 4.90618 20.5612 4.62618 20.256C1.02645 16.3319 1.12735 10.2315 4.92893 6.42991C8.83417 2.52467 15.1658 2.52467 19.0711 6.42991C22.8726 10.2315 22.9735 16.3319 19.3738 20.256C19.0938 20.5612 18.6194 20.5817 18.3141 20.3017C18.0089 20.0217 17.9884 19.5472 18.2685 19.242C21.3275 15.9073 21.2415 10.7217 18.0104 7.49057ZM8.21967 9.72065C8.51256 9.42775 8.98743 9.42775 9.28033 9.72065L12.5303 12.9706C12.8232 13.2635 12.8232 13.7384 12.5303 14.0313C12.2374 14.3242 11.7626 14.3242 11.4697 14.0313L8.21967 10.7813C7.92677 10.4884 7.92677 10.0135 8.21967 9.72065Z",
		fill: "currentColor"
	})
});
//#endregion
export { LowData };
